module.exports = __webpack_public_path__ + "img/advantage2@2x.8cdd2709.png";